import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { execute, reset } from './actions';
import { InferenceResult } from '../../../models/InferenceResult';
import { InferenceAdditionalResult } from '../../../models/InferenceAdditionalResult';

export interface InferenceResultState {
  loaded: boolean;
  results: InferenceResult[];
  additionalResult: InferenceAdditionalResult;
  croppedImage: {
    bucket: string;
    key: string;
  }
}

const initialState: InferenceResultState = {
  loaded: false,
  results: [],
  additionalResult: new InferenceAdditionalResult(),
  croppedImage: {
    bucket: '',
    key: ''
  }
};

const reducer = reducerWithInitialState(initialState)
  .case(execute.started, (state) => {
    return { ...state, loaded: false, result: {} };
  })
  .case(execute.done, (state, param) => {
    return {
      ...state,
      loaded: true,
      results: param.result.results,
      additionalResult: param.result.additionalResult,
      croppedImage: param.result.croppedImage
    };
  })
  .case(execute.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })

  .case(reset, (state) => {
    return { ...initialState };
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/inference/reducers.ts